/* src/app/shared/dialogs/dynamic-variable-dialog/dynamic-variable-dialog.component.scss */
.dialog-root {
  width: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dynamic-variable-dialog-container {
  padding-bottom: 0px;
  width: 100%;
  flex-shrink: 0;
}
.data-container {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
}
.select-container {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  padding: 24px 24px 0 24px;
  display: flex;
  flex-direction: column;
}
.select-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.select-footer {
  flex-shrink: 0;
}
p {
  color: #5c5c5c;
}
.data-container::-webkit-scrollbar,
.select-scroll::-webkit-scrollbar {
  width: 8px !important;
}
.data-container::-webkit-scrollbar-thumb,
.select-scroll::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  height: 8px !important;
  width: 8px !important;
  border-radius: 10px;
}
.data-container::-webkit-scrollbar-track,
.select-scroll::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}
h4 {
  color: #222222;
  font-size: 16px;
  line-height: 24px;
}
.body-regular {
  color: #5c5c5c;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.body-medium {
  color: #222222;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.label-regular {
  color: #222222;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.entryfields {
  justify-content: space-between;
}
.back-button {
  color: #222222;
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 21px;
  background-color: transparent;
  border: none;
}
.input-field {
  width: 100%;
  height: 40px;
  border-radius: 12px;
  background: transparent;
  border: none;
  padding: 0px;
}
.input-field:focus-visible {
  outline: none;
}
.input-field::placeholder {
  color: #5c5c5c;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 21px;
}
.input-wrapper {
  width: 100%;
  height: 56px;
  background: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #f2f2f2;
}
.input-wrapper:focus-within {
  background: #ffffff;
}
.magnifier {
  filter: brightness(0) saturate(100%) invert(36%);
  height: 20px;
  width: 20px;
}
.input-wrapper:focus-within .magnifier {
  filter: none;
}
.grey-input-wrapper {
  width: 100%;
  height: 40px;
  border-radius: 12px;
  background: #f2f2f2;
  display: flex;
  flex-direction: row;
}
.grey-input-field {
  width: 100%;
  height: 40px;
  border-radius: 12px;
  background: transparent;
  border: none;
  padding-left: 16px;
}
.grey-input-field:focus-visible {
  outline: none;
}
.line {
  position: relative;
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
}
.or-box {
  position: absolute;
  background-color: #ffffff;
  top: -10px;
  left: 45%;
  width: 36px;
  text-align: center;
}
.black-radio {
  width: 20px;
  min-width: 20px;
  height: 22px;
  border: 1px solid #a6a6a6;
  outline: none;
  position: relative;
  display: inline-block;
  accent-color: #222222;
}
.black-radio:checked::before {
  content: "";
  width: 4px;
  height: 4px;
  background-color: #222222;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  outline: none;
  transform: translate(-50%, -50%);
}
.black-radio:focus {
  outline: none;
  box-shadow: none;
}
/*# sourceMappingURL=dynamic-variable-dialog.component.css.map */
